import React from 'react'
import BetterLineItemMergeModal from './BetterLineItemMergeModal'

type Props = {
  show: boolean
  handleClose: () => void
  data?: any
  selectedDraftData: any
  refetch?: any
  setShowInnerTable?: any
  onSuccess?: () => void
}

/**
 * Merge Line Items entry (Receipt Vault / Expense Line Items / Drafts).
 * Always opens Merge Line Items (V2) — BetterLineItemMergeModal + *V2 APIs.
 * V1 (Merge With Bank LineItems) is not used from this gate.
 */
const MergeExpenseGate = (props: Props) => {
  return <BetterLineItemMergeModal {...props} />
}

export default MergeExpenseGate
